import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { LayerType } from '@/version-types';
import { ContextMenuPlugin } from '../../../context-menu';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer, operateLayerType }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (!operateLayerType) return null;
    if (operateLayerType === LayerType.BACKGROUND_LAYER) return null;
    if (operateLayerType === LayerType.MAIN_LAYER) return null;
    if (operateLayerType === LayerType.WATERMARK) return null;

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.addMySpace),
        type: 'saveToMySpace',
        icon: 'UploadFlowBold',
        onClick: () => {
            framework.getInstance(ContextMenuPlugin).saveToMySpace();
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 1,
    render,
} as IExportContextMenuItem;
